// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr } from "../../revvComponents";

import EvidenaceSummaryPopup from "./EvidenceSummaryPopup";

// Actions Imports
import { getEvidenceSummaryService } from "../../actions/RevvSign/revvSignService";
import { buttonClickEvent } from "../../gtm/gtmutils";
import GTM_EVENTS from "../../gtm/gtmevents";
import { AmplitudeUtils } from "../../utils";
import { EVENTS } from "../../constants";
import LZLoader from "../../commonComponents/LZLoader";

class EsignDocHeaderEvidenceSummary extends Component {
  static documentHTMLData = "";

  state = {
    showMoreOptions: false,
    isLoading: false,
  };

  // this code is responsible for concat type of Signature sections data
  _fetchSignersList = () => {
    const { content } = this.props;
    const signerData = [];
    content.sections.forEach(section => {
      if (
        section.type === "Signature" &&
        section.data &&
        section.data.length > 0
      ) {
        signerData.push(...section.data);
      }
    });
    return signerData;
  };

  _toggleNavbarPopup = (type, flag) => {
    this.setState({ [type]: flag });
  };

  showMoreOptions = event => {
    if (!this.state.showMoreOptions) {
      AmplitudeUtils.amplitudeLogEventLZ(
        EVENTS.EVENT_NAMES.CLICK_DOCUMENT_DETAILS,
        {
          source: EVENTS.SOURCE_LZ.DOCUMENT_EDITOR,
          screen: EVENTS.SCREEN_LZ.SIGNING_PAGE,
          document_type: EVENTS.DOCUMENT_TYPE.PDF,
          document_origination: this.props.isLz
            ? EVENTS.DOCUMENT_ORIGINATION_LZ.LZ
            : EVENTS.DOCUMENT_ORIGINATION_LZ.REVV,
        },
      );
      buttonClickEvent(GTM_EVENTS.SIGNINGCEREMONY_DOCDETAILS_CLICK);
    }
    event.preventDefault();
    const { showMoreOptions } = this.state;
    this.setState({
      showMoreOptions: !showMoreOptions,
    });
  };

  _downloadEvidenceSummary = () => {
    const { pathname } = window.location;
    let shared = false;
    if (pathname.split("/").includes("shared")) {
      shared = true;
    }
    buttonClickEvent(
      GTM_EVENTS.SIGNINGCEREMONY_DOCDETAILSPOPUP_ESIGN_SUMMARY_DOWNLOAD_CLICK,
    );
    this.setState({
      isLoading: true,
    });
    getEvidenceSummaryService(
      this.props.docID,
      this.props.sharingHash,
      shared,
      this.props.isLz,
    )
      .then(response => {
        const docMIMEType = "application/pdf";
        const file = new Blob([response], {
          type: docMIMEType,
        });
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(
            file,
            `${this.props.docName} - Evidence Summary`,
          );
        } else {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(file);
          link.setAttribute(
            "download",
            `${this.props.docName} - Evidence Summary`,
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        this.setState({
          isLoading: false,
        });
        Toastr.showToastr({
          type: "success",
          message: "Your document has been downloaded successfully.",
          timeout: 3000,
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({
          isLoading: false,
        });
        Toastr.showToastr({
          type: "failure",
          message: "Error while downloading",
          timeout: 3000,
        });
      });
  };

  render() {
    if (this.state.isLoading) {
      return (
        <LZLoader
          className="saving-document"
          label="Downloading your esign evidence summary"
          theme="dark"
          fullScreen
        />
      );
    }
    return (
      <Fragment>
        <div className="recipientdocheaderdownloadbutton-container">
          <div className="recipientdocheaderdownloadbutton-container">
            <span
              className="recipientdocheader-download-button"
              role="button"
              data-test="quotation-draft-btns-more"
              tabIndex="0"
              onClick={this.showMoreOptions}
              onKeyPress={this.showMoreOptions}>
              <FontAwesomeIcon
                icon={["fas", "clipboard-check"]}
                color="#252424"
                className="recipientesignheaderbuttons-icon"
              />
            </span>

            <EvidenaceSummaryPopup
              docID={this.props.docID}
              docObjectId={this.props.docObjectId}
              docObjectIdShared={this.props.docObjectIdShared}
              isLz={this.props.isLz}
              docName={this.props.docName}
              sharingHash={this.props.sharingHash}
              downloadEvidenceSummary={this._downloadEvidenceSummary}
              signatories={this.props.signatories}
              docStage={this.props.docStage}
              showMoreOptions={this.state.showMoreOptions}
              handleClosePopup={this.showMoreOptions}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default EsignDocHeaderEvidenceSummary;
